import { patientHttpService } from "../store/patient-http-service";
import { patientAuthToken } from "./patient-auth-token";
import { authServiceProvider } from "../../auth/auth-service";

export const patientAuthService = authServiceProvider({
  httpService: patientHttpService,
  authToken: patientAuthToken,
});
